// Yahoo API Configuration
export const YAHOO_API_CONFIG = {
  CLIENT_ID: 'dj0yJmk9VnR6R244Y3NlMWhkJmQ9WVdrOWRFRlFOMlpRVTJvbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTli', // Replace with your actual Client ID
  CLIENT_SECRET: '3cfc60db0b9f36ac25b19bcf25485c8913c68014', // Replace with your actual Client Secret
  REDIRECT_URI: 'https://fab4-2600-1700-e02-3820-79c6-94bd-4ca0-3af6.ngrok-free.app/callback', // Your ngrok URL with callback path
  AUTH_BASE_URL: 'https://api.login.yahoo.com/oauth2/request_auth',
  TOKEN_URL: 'https://api.login.yahoo.com/oauth2/get_token',
  API_BASE_URL: 'https://fantasysports.yahooapis.com/fantasy/v2',
  SCOPE: 'fspt-r'  // Yahoo's fantasy sports read scope
};

// TheSportsDB API configuration - updated to use correct free API key from documentation
export const SPORTSDB_API_CONFIG = {
  // Use the correct free API key (123) as documented at https://www.thesportsdb.com/documentation
  BASE_URL: 'https://www.thesportsdb.com/api/v1/json/123',
  API_KEY: '123', // Free tier API key as documented
  SEARCH_URL: 'searchplayers.php',
  LOOKUP_URL: 'lookupplayer.php',
  TEAM_URL: 'lookupteam.php',
  TEAM_SEARCH_URL: 'searchteams.php',
  LEAGUE_SEARCH_URL: 'search_all_leagues.php',
  TEAM_PLAYERS_URL: 'lookup_all_players.php',
  TEAMS_IN_LEAGUE_URL: 'search_all_teams.php'
};

// Player image API - updated to use correct free API key
export const PLAYER_IMAGE_API = {
  BASE_URL: 'https://www.thesportsdb.com/api/v1/json/123/searchplayers.php'
}; 